// extracted by mini-css-extract-plugin
export default {"paymentOption":"PaymentOption_paymentOption__pKyyW","partialPayment":"PaymentOption_partialPayment__yBsH-"};